<template>
    <div class="file-resource-card">
        <b-form-row class="preview">
            <b-col
                    cols="8"
                    md="9"
                    class="left-items"
            >
                <file-resource-thumbnail :file-app-resource="fileAppResource" />
                <div class="details">
                    <div class="filename">
                        {{ fileAppResource.fileTitle }}
                    </div>
                </div>
            </b-col>
            <b-col
                    cols="4"
                    md="3"
                    class="right-items"
            >
                <span
                        class="remove far fa-times"
                        @click="$emit('remove-file', fileAppResource)"
                />
            </b-col>
        </b-form-row>
    </div>
</template>

<script>
    import './FileResourceCard.scss';
    import FileAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource';
    import FileResourceThumbnail from '../FileResourceThumbnail/FileResourceThumbnail.vue';

    export default {
        name: 'FileResourceCard',
        layout: 'default',

        components: {
            FileResourceThumbnail,
        },

        props: {
            fileAppResource: {
                type: FileAppResource,
                required: true,
            },
        },
    };
</script>
